<template><div class="row">

    <div
      class="sk-spinner sk-spinner-wave"
      style="display: block;"
    >
      <div class="sk-rect1"></div>
      <div class="sk-rect2"></div>
      <div class="sk-rect3"></div>
      <div class="sk-rect4"></div>
      <div class="sk-rect5"></div>
    </div>
  </div>
</template>
<script>
export default {

};
</script>
